import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import { updateFilters } from 'actions/planner-filters';
import { AdvFilterV2Context, FilterIcon } from '../filterContext';


const SelectFilter = ({title, payloadKey, selectOptions}) => {
  const dispatch = useDispatch();
  const value = useSelector((state) => state.plannerFilters[payloadKey]);
  const v2 = useContext(AdvFilterV2Context);

  return (
    <Grid container spacing={2} alignItems='center' justifyContent='space-evenly' sx={{ mb: 2 }}>
          <Grid item xs={3}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
              {v2 && <FilterIcon title={title} />}
              {title}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Select
              name={payloadKey}
              value={value || (v2 ? '' : value)}
              displayEmpty={v2}
              renderValue={
                v2
                  ? (sel) =>
                      sel === '' || sel == null ? (
                        <span style={{ color: '#9aa1b2' }}>{`Select ${title.toLowerCase()}`}</span>
                      ) : (
                        (selectOptions.find((o) => o.value === sel) || {}).label || sel
                      )
                  : undefined
              }
              onChange={(event) => {
                dispatch(updateFilters(payloadKey, event.target.value))
              }}
              label={payloadKey}
              fullWidth
              size='small'
            >
              {selectOptions.map(option => {
                return <MenuItem value={option.value}>{option.label}</MenuItem>
              })}
            </Select>
          </Grid>
        </Grid>
  )
}

export default SelectFilter;